div// 外销隐私声明组件
<template>
  <section v-if="!vm.isMobile" class="privacy-protection-oversea" :class="{ zh: lang == 'zh' }">
    <div v-textMotion="400" class="privacy-protection-oversea-text-intro">
      <p class="title">{{ $t('privacy-protection-oversea-title') }}</p>
      <p class="sub-title">{{ $t('privacy-protection-oversea-sub-title') }}</p>
      <p class="description">{{ $t('privacy-protection-oversea-description') }}</p>
    </div>
    <div v-if="lang === 'zh'" class="privacy-protection-oversea-logo-wrap">
      <img
        v-lazy="require('../../assets/zh/privacy/logo1.png')"
        class="logo1 wow textInPartMotion"
        data-wow-offset="370"
        data-wow-delay="0s"
        data-wow-duration=".8s"
        alt="ColorOS 11"
      />
      <img
        v-lazy="require('../../assets/zh/privacy/logo2.png')"
        class="logo2 wow textInPartMotion"
        data-wow-offset="370"
        data-wow-delay="0.4s"
        data-wow-duration=".8s"
        alt="ColorOS 11"
      />
      <img
        v-lazy="require('../../assets/zh/privacy/logo3.png')"
        class="logo3 wow textInPartMotion"
        data-wow-offset="370"
        data-wow-delay="0.8s"
        data-wow-duration=".8s"
        alt="ColorOS 11"
      />
      <img
        v-lazy="require('../../assets/zh/privacy/logo4.png')"
        class="logo4 wow textInPartMotion"
        data-wow-offset="370"
        data-wow-delay="1.2s"
        data-wow-duration=".8s"
        alt="ColorOS 11"
      />
    </div>
    <div v-else class="privacy-protection-oversea-logo-wrap">
      <img
        v-lazy="require('../../assets/privacy/logo1.png')"
        class="logo1 wow textInPartMotion"
        data-wow-offset="370"
        data-wow-delay="0s"
        data-wow-duration=".8s"
        alt="ColorOS 11"
      />
      <img
        v-lazy="require('../../assets/privacy/logo2.png')"
        class="logo2 wow textInPartMotion"
        data-wow-offset="370"
        data-wow-delay="0.4s"
        data-wow-duration=".8s"
        alt="ColorOS 11"
      />
      <img
        v-lazy="require('../../assets/privacy/logo3.png')"
        class="logo3 wow textInPartMotion"
        data-wow-offset="370"
        data-wow-delay="0.8s"
        data-wow-duration=".8s"
        alt="ColorOS 11"
      />
      <img
        v-lazy="require('../../assets/privacy/logo4.png')"
        class="logo4 wow textInPartMotion"
        data-wow-offset="370"
        data-wow-delay="1.2s"
        data-wow-duration=".8s"
        alt="ColorOS 11"
      />
    </div>
  </section>
  <section v-else class="privacy-protection-oversea-mobile">
    <div class="privacy-protection-oversea-mobile-background"></div>
    <div v-textMotion="100" class="privacy-protection-oversea-text-intro">
      <p class="title">{{ $t('privacy-protection-oversea-title') }}</p>
      <div v-if="lang === 'zh'" class="sub-title">
        <p>{{ $t('privacy-protection-oversea-sub-title1') }}</p>
        <p>{{ $t('privacy-protection-oversea-sub-title2') }}</p>
      </div>
      <p v-else class="sub-title">{{ $t('privacy-protection-oversea-sub-title') }}</p>
      <p class="description">{{ $t('privacy-protection-oversea-description') }}</p>
    </div>
    <div class="privacy-protection-oversea-logo-wrap">
      <img
        v-lazy="require('../../assets/privacy/logo1m.png')"
        class="logo1 wow textInPartMotion"
        alt="ColorOS 11"
        data-wow-duration=".7s"
        data-wow-delay="0s"
        data-wow-offset="100"
      />
      <img
        v-lazy="require('../../assets/privacy/logo2m.png')"
        class="logo2 wow textInPartMotion"
        alt="ColorOS 11"
        data-wow-duration=".7s"
        data-wow-delay="0s"
        data-wow-offset="100"
      />
      <img
        v-lazy="require('../../assets/privacy/logo3m.png')"
        class="logo3 wow textInPartMotion"
        alt="ColorOS 11"
        data-wow-duration=".7s"
        data-wow-delay="0.3s"
        data-wow-offset="100"
      />
      <img
        v-lazy="require('../../assets/privacy/logo4m.png')"
        class="logo4 wow textInPartMotion"
        alt="ColorOS 11"
        data-wow-duration=".7s"
        data-wow-delay="0.3s"
        data-wow-offset="100"
      />
    </div>
  </section>
</template>
<script>
export default {
  inject: ['vm', 'lang']
};
</script>
<style lang="scss">
.privacy-protection-oversea {
  height: 100vh;
  min-height: 800px;
  overflow: hidden;
  position: relative;
  z-index: 1;
  text-align: center;
  &-text-intro {
    width: 100vw;
    user-select: none;
    position: absolute;
    top: 24.8%;
    .description {
      padding-top: 24px;
      max-width: 576px;
      margin: 0 auto;
      line-height: 1.5;
      color: rgba(0, 0, 0, 0.55);
    }
  }
  &-logo-wrap {
    width: 100vw;
    position: absolute;
    bottom: 39.5%;
    > img {
      -webkit-user-drag: none;
      width: 208px;
    }
    .logo1 {
      width: 78px;
      margin-left: 4px;
    }
    .logo2 {
      margin-left: 88px;
    }
    .logo3 {
      margin-left: 59px;
    }
    .logo4 {
      width: 264px;
      margin-left: 35px;
    }
  }
}
.flowing-text-img {
  width: 100vw;
  top: 0;
  left: 0;
  position: absolute;
}
.privacy-protection-oversea-mobile-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0e0e0e;
}
.privacy-protection-oversea-mobile {
  position: relative;
  text-align: left;
  height: 132vw;
  position: relative;
  background: #0e0e0e;
  .privacy-protection-oversea-text-intro {
    position: relative;
    z-index: 1;
    width: 100vw;
    user-select: none;
    position: absolute;
    top: 13.33vw;
    box-sizing: border-box;
    padding: 0 20px;
    .title {
      color: #fff;
    }
    .sub-title {
      color: #fff;
      max-width: 80%;
    }
    .description {
      padding-top: 20px;
      font-size: 13px;
      line-height: 21px;
      color: rgba(255, 255, 255, 0.5);
      margin: 0;
    }
  }
  .privacy-protection-oversea-logo-wrap {
    width: 100vw;
    box-sizing: border-box;
    padding-left: 24px;
    position: absolute;
    z-index: 1;
    bottom: 18.87vw;
    > img {
      -webkit-user-drag: none;
      width: 32.53vw;
      margin: 0;
    }
    .logo1 {
      width: 12vw;
      margin-right: 31.46vw;
      margin-bottom: 8vw;
    }
    .logo2 {
      width: 41.07vw;
      margin-bottom: 8vw;
    }
    .logo3 {
      margin-right: 11.2vw;
    }
  }
  .flowing-text-img {
    display: none;
  }
}
@media screen and (max-width: 374px) {
  .privacy-protection-oversea-mobile {
    .privacy-protection-oversea-logo-wrap {
      bottom: 10vw;
    }
  }
}
// 20200924补 内销的上间距缩小
.zh {
  .privacy-protection-oversea-text-intro {
    top: 12%;
  }
  .privacy-protection-oversea-logo-wrap {
    bottom: 52%;
  }
}
</style>
